module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="isAbsent">\r\n	<div class="isAbsent__container">\r\n		<div class="isAbsent__icon"></div>\r\n		<div class="isAbsent__text">\r\n			<div class="isAbsent__title">Выбранный вами тур раскупили, ниже вы можете ознакомиться с доступными турами</div>\r\n			<div class="isAbsent__criteria"></div>\r\n		</div>\r\n	</div>\r\n</div>';
}
return __p;
};
